import aoflModules from 'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min';
const storeService = aoflModules.store;

export default function(riqApiService) {
  return {
    getFeatures: () =>
      riqApiService
        .get('getFeatures')
        .then(payload => {
          storeService.commit([
            {
              mutationId: 'setFeatures',
              stateAlias: 'feature',
              payload
            }
          ]);
        })
        .catch(console.error)
  };
}

const featureToPermissionMap = {
  holidayTeacherRewardsPromotion2019: 'view_holiday_offer_2019'
};

const namespace = 'feature';
const state = {
  namespace,
  alias: namespace,
  mutations: {
    init: () => ({
      enabled: []
    }),
    setFeatures: function(_moduleState, payload) {
      const enabled = Object.keys(payload).filter(key => payload[key]);
      return {
        enabled,
        permissionList: enabled
          .map(feature => featureToPermissionMap[feature])
          .filter(permission => Boolean(permission))
      };
    }
  }
};

aoflModules.ready.then(() => storeService.addState(state));
